const FAQS: { module: string; items: { q: string; a: string }[] }[] = [
  {
    module: 'Administration',
    items: [
      {
        q: 'Why can\'t I see a menu item other users can see?',
        a: 'Menu visibility follows your assigned Access Right and App Access under Administration. Ask an administrator to grant your user access to that module, or to enable SHOW on the relevant Access Right.',
      },
      {
        q: 'How do I reset an employee\'s password?',
        a: 'Go to Administration → Employee Access, select the employee (or select multiple for a bulk reset), and use the Reset Password action.',
      },
    ],
  },
  {
    module: 'Payroll',
    items: [
      {
        q: 'Why doesn\'t Salary Adjustment show my latest profile change?',
        a: 'Salary Adjustment works from a snapshot taken at Payroll Initialize. Re-run Initialize for the affected employee after a profile change, or use Recalculate before Update.',
      },
      {
        q: 'Why is CPF $0 on a bi-monthly MID run?',
        a: 'By default, MID runs are a salary advance with no CPF withheld; the full month\'s CPF is deducted on the matching END run. This can be changed in Payroll System Settings.',
      },
    ],
  },
  {
    module: 'Time Management',
    items: [
      {
        q: 'What is the difference between Reprocess and Recalculate?',
        a: 'Reprocess rebuilds attendance from the raw clock data using the latest shift setup (overwrites manual edits unless the row is locked). Recalculate keeps the stored In/Out times and only redoes lateness/OT/allowance math.',
      },
      {
        q: 'How is an employee\'s shift decided for a given day?',
        a: 'In priority order: an explicit Employee Schedule entry, then Duty Roster, then Auto Shift matching, then the employee\'s default shift.',
      },
    ],
  },
  {
    module: 'Leave',
    items: [
      {
        q: 'Why did my leave day-count skip a weekend day?',
        a: 'The employee\'s assigned Exclude Days group and public holidays are automatically skipped when computing leave days.',
      },
      {
        q: 'Can a Super Admin cancel my approved leave for me?',
        a: 'No — only the employee or their approvers may request cancellation of an approved leave application.',
      },
    ],
  },
  {
    module: 'Claims',
    items: [
      {
        q: 'Why was my claim blocked?',
        a: 'A per-visit, monthly, or yearly Claim Limit assigned to you was exceeded. Ask your administrator if "Allow Exceed Limit" should be enabled for this claim.',
      },
    ],
  },
  {
    module: 'Appraisal',
    items: [
      {
        q: 'Why do evaluation and factor scores need to total 100%?',
        a: 'The template builder enforces this so the final quantitative score is always a percentage out of 100, comparable across employees and grades.',
      },
    ],
  },
];

export default function KnowledgeBase() {
  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Knowledge Base &amp; FAQ</h1>
      <p className="text-sm text-gray-500 mb-6">
        Answers to common questions about using MAVIS HRMS. Contact Support for anything not covered here.
      </p>
      <div className="space-y-6">
        {FAQS.map((section) => (
          <div key={section.module} className="bg-white rounded-lg shadow p-4">
            <h2 className="font-semibold text-gray-800 mb-3">{section.module}</h2>
            <div className="divide-y">
              {section.items.map((item) => (
                <details key={item.q} className="py-2 group">
                  <summary className="cursor-pointer text-sm font-medium text-gray-700 list-none flex justify-between items-center">
                    {item.q}
                    <span className="text-gray-400 group-open:rotate-180 transition-transform">▾</span>
                  </summary>
                  <p className="text-sm text-gray-600 mt-2">{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
